import { createBrowserRouter } from 'react-router-dom'
import MainLayout from './layouts/main'
import NotFound from './components/common/NotFound'

const router = createBrowserRouter([
  { path: '/', element: <MainLayout /> },
  { path: '*', element: <NotFound /> }
])

export default router
